import commonConfig from "config/commonConfig";
import { isNaN, isUndefined } from "lodash";
import { ROUTES, ROUTE_SLUGS } from "utils/constants/route.constants";
import {
  getWindowLocationValues,
  locationKeys,
} from "utils/window-utils/window-utils";

export const NOT_FOUND = {
  image:
    "https://storage.googleapis.com/sheen-upload/Assets/Common/oopsNotFound.png",
  imageNotFound:
    "https://storage.googleapis.com/sheen-upload/Assets/Common/image-not-found.jpg",
};
export const debouncedRate = {
  faster: 50,
  fast: 100,
  littleDelay: 300,
  delay: 500,
  hugeDelay: 700,
};

export const orderStatus = {
  inReview: "In review",
  accepted: "Accepted",
  making: "Making",
  dispatched: "Dispatched",
  delivered: "Delivered",
  canceled: "Canceled",
};
export const PAGE_SIZE = 8;

export const Karat = [75, 92];
export const Tone = ["Bombay", "Calcutta"];
export const colors = ["R", "W", "Y", "RW", "RY", "YW", "RWY"];

// export const getPagesNumbers = () => { // TODO Remove this code
//   const pageNumbers = [];
//   const pageTitles = ["", "", ""];

//   for (let i = 1; i <= 3; i++) {
//     pageNumbers.push(
//       <Pagination.Item
//         key={i}
//         onClick={() => goToPage(i - 1)}
//         active={i === currentPage}
//       >
//         {pageTitles[i - 1]}
//       </Pagination.Item>
//     );
//   }

//   return [...pageNumbers];
// };

/**
 * The function returns client details based on the current hosted URL.
 * @param clientsData - an object containing client details, where each key is a unique identifier for
 * a client and each value is an object containing details about that client (such as their domain,
 * name, and logo).
 * @returns The function `getClientDetails` returns an object that matches the client data for the
 * current hosted URL. If there is a match, it returns the client data object, otherwise it returns
 * `null`.
 */
export const getClientDetails = (clientsData) => {
  const currentHostedUrl = getWindowLocationValues(locationKeys.origin);

  return Object.entries(clientsData).reduce((acc, [key, value]) => {
    if (
      currentHostedUrl
        ?.toString()
        .toLowerCase()
        .match(value.domain?.toString().toLowerCase())
    ) {
      acc = value;
    }
    return acc;
  }, null);
};

/**
 * This is a reducer function that returns the state with the action object spread onto it.
 * @returns The `reducerWithoutAction` function is returning a new object that merges the current state
 * with the action object using the spread operator.
 */
export const reducerWithoutAction = (state, action) => {
  return {
    ...state,
    ...action,
  };
};

// export const handleQuantity = async (itemIndex, { add, subtract, remove }) => { // TODO remove this code
//   let items = yourCartItems?.items || [];

//   if (add) {
//     // Add and save to AsyncStoragelogic
//     items[itemIndex] = items[itemIndex] || {};
//     items[itemIndex].quantity = items[itemIndex].quantity
//       ? items[itemIndex].quantity + 1
//       : 1;
//   } else if (subtract) {
//     // Subtract and save to AsyncStoragelogic
//     items[itemIndex] = items[itemIndex] || {};
//     items[itemIndex].quantity = items[itemIndex].quantity - 1;
//     if (items[itemIndex].quantity <= 0) {
//       items.splice(itemIndex, 1);
//     }
//   } else if (remove) {
//     items.splice(itemIndex, 1);
//   }

//   setCartItems({ ...yourCartItems, items } || {});
// };

export const getAuthPath = (isLogin = true) =>
  ROUTES.AUTH_TYPE.replace(
    ROUTE_SLUGS.authType,
    isLogin ? "login" : "register"
  );

export const getColorWithOrderStatus = (_orderStatus) => {
  if (_orderStatus === orderStatus.inReview) {
    return "#A54201";
  }
  if (_orderStatus === orderStatus.accepted) {
    return "#388e3c";
  }

  if (_orderStatus === orderStatus.canceled) {
    return "#d32f2f";
  }

  return "#A54201";
};

export const getSelectedColorInitial = {
  "#f44336": "R",
  "#e91e63": "P",
  "#9c27b0": "W",
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const getMainClient = () => getClientDetails(commonConfig?.clients);

export const getAccumulatedProductEntity = (items, entity) => {
  const value = items?.reduce(
    (total, product) =>
      total +
      (product?.product && product?.product[entity] * product?.quantity),
    0
  );

  return isNaN(value) ? "--" : value;
};

export const getOverallOrderStatus = (orders) => {
  const orderStatuses = [
    "In review",
    "Accepted",
    "Making",
    "Dispatched",
    "Delivered",
    "Canceled",
  ];

  for (const status of orderStatuses) {
    if (orders.some((order) => order.orderStatus === status)) {
      return status;
    }
  }

  return ""; // If no matching status is found
};

/**
 * The function sets the specified key-value pair in the search parameters of a given location.
 * @param location - The `location` parameter represents the current URL location object. It typically
 * contains information about the current URL, such as the protocol, host, pathname, and search
 * parameters.
 * @param params - {
 * @returns the updated search parameters as a URLSearchParams object.
 */
export const setSearchParamsInLocation = (location, params) => {
  const searchParams = new URLSearchParams(location?.search);

  searchParams.set(params?.key, params?.value);

  return searchParams;
};

export const getScrewValue = (melting) => {
  if (melting === Karat[0]) {
    return Tone[0];
  }
  if (melting === Karat[1]) {
    return Tone[1];
  }
};

export const getMeltingValue = (screw) => {
  if (isUndefined(screw)) {
    return Karat[0];
  }
  if (screw === Tone[0]) {
    return Karat[0];
  }
  if (screw === Tone[1]) {
    return Karat[1];
  }
};

export const capitalizeFirstLetter = (string) => {
  return string?.replace(/^./, string[0].toUpperCase());
};
